import { useMutation } from "@tanstack/react-query";

import { getMeasurementBulletin } from "@/adapters/api";
import { toBulletin } from "../utils/map.ts";

export function useMeasurementBulletin(constructionId: string) {
	return useMutation({
		mutationFn: async ({ from, to }: { from: string; to: string }) =>
			toBulletin(await getMeasurementBulletin(constructionId, from, to)),
	});
}
